import { Package, Paperclip, Puzzle } from 'lucide-react';
import { useSearchParams } from 'react-router-dom';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../ui/components/ui/tabs';
import AddOnListWrapper from './components/add-on-list/add-on-list.wrapper';
import AttachmentListWrapper from './components/attachment-list/attachment-list.wrapper';
import ProductListWrapper from './components/product-list/product-list.wrapper';
import { ProductTab } from './constants/product-tab.enum';
import { PRODUCTS_SEARCH_PARAM } from './constants/products-page.constants';
import { isProductTab } from './lib/enum-guards';

const ProductsPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const rawTab = searchParams.get(PRODUCTS_SEARCH_PARAM.tab);
  const activeTab = isProductTab(rawTab) ? rawTab : ProductTab.PRODUCTS;

  // Filter and page belong to the list of the active tab, so they start fresh on every tab switch.
  const handleTabChange = (value: string) => {
    if (!isProductTab(value) || value === activeTab) return;
    setSearchParams((prev) => {
      const params = new URLSearchParams(prev);
      params.set(PRODUCTS_SEARCH_PARAM.tab, value);
      params.delete(PRODUCTS_SEARCH_PARAM.filter);
      params.set(PRODUCTS_SEARCH_PARAM.page, '1');
      return params;
    });
  };

  return (
    <>
      <div>
        <h1 className="text-[32px] leading-[38px] font-bold text-[#12282A]">Produktmanagement</h1>
        <p className="text-[16px] text-[#888]">Produkte, Add-ons und Mail-Anhänge verwalten</p>
      </div>

      <Tabs value={activeTab} onValueChange={handleTabChange} className="w-full">
        <TabsList className="gap-4">
          <TabsTrigger value={ProductTab.PRODUCTS}>
            <Package className="h-5 w-5" />
            Produkte
          </TabsTrigger>
          <TabsTrigger value={ProductTab.ADD_ONS}>
            <Puzzle className="h-5 w-5" />
            Add-ons
          </TabsTrigger>
          <TabsTrigger value={ProductTab.ATTACHMENTS}>
            <Paperclip className="h-5 w-5" />
            Mail-Anhänge
          </TabsTrigger>
        </TabsList>
        <TabsContent value={ProductTab.PRODUCTS}>
          <ProductListWrapper />
        </TabsContent>
        <TabsContent value={ProductTab.ADD_ONS}>
          <AddOnListWrapper />
        </TabsContent>
        <TabsContent value={ProductTab.ATTACHMENTS}>
          <AttachmentListWrapper />
        </TabsContent>
      </Tabs>
    </>
  );
};

export default ProductsPage;
